import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbAwardedBestCsg = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Indo Zambia Bank is proud to be awarded Best Customer Service Organisation of the Year – Private Sector 2024</h1>

                <p className="pb-3">This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone.</p>

                <p className="pb-3">At the same event, Indo Zambia Bank was awarded Best Customer Service Organisation of the Year – Private Sector 2024 . This recognition holds special significance, and we dedicate it to you, our valued customers. Your trust and loyalty continue to inspire us, and this award truly belongs to you.</p>

                <p className="pb-3">We were also named runners-up in the Most Creative Print Advertisement of the Year 2024 category for our Indo Home Loan campaign.</p>

                <p className="pb-3">As we celebrate these achievements, we remain committed to delivering service excellence and putting our customers at the heart of everything we do.</p>
      

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-2.png" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-1.png" alt="" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-3.png" alt="" />
                  </div>
                </Slider>
              </div>
            </div>

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbAwardedBestCsg;